// this file is generated by update_shopify_store_data.py at 2025-05-13 20:33:33.415437
var courses = [
    {
        "course_id": "E94C3712-B98C-EB11-80DF-005056B16DD5",
        "course_version": 7,
        "name": "CQ Acute: HIPAA, Patient Rights",
        "course_type": 1,
        "author_information": "Debbie Curl-Nagy, MSW, LSSMBB",
        "description": "This module reviews the Health Insurance Portability and Accountability Act (HIPAA) Privacy Rule. The purpose and elements of the Notice of Privacy Practices (NPP) are discussed as well as patient rights regarding their protected health information (PHI).",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Discuss patient rights under the HIPAA Privacy Rule.</li>\r\n    <li>\r\n    List the four requirements that must be included in the Notice of Privacy Practices.</li>\r\n    <li>\r\n    Relate patient needs for privacy to their rights under the HIPAA Privacy Rule.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "82CDE1E0-3FD6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E52CB629-9691-EB11-80E1-005056B13D3F",
                "course_category_name": "KnowledgeQ Microlearning Compliance - HIPAA (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "67CCBB16-6533-EC11-80E9-005056B14E20",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers",
                "is_system_course_category": null
            },
            {
                "course_category_id": "90B55558-03C9-E511-8771-005056B104B1",
                "course_category_name": "Urgent Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                "course_category_name": "Competency: HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8D33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Law and Ethics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8BB82E9D-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - ComplyQ [All Settings] [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                "course_category_name": "_ComplyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DA1A6031-6D0A-F011-9997-005056A7AAEE",
                "course_category_name": "HSTM - ComplyQ for Rev Cycle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9B9EDD5-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C033B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EFA61FCF-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - ComplyQ Acute [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Privacy and Security",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "1BA21285-3B7C-EB11-80DF-005056B14F81",
        "course_version": 8,
        "name": "CQ Acute: HIPAA, Privacy Rule",
        "course_type": 1,
        "author_information": "Jackie Luchsinger, PhD, MBA, MS, RN, PMP",
        "description": "This module provides an overview of the HIPAA Privacy Rule. The module discusses the basic components of the Privacy Rule, including general information and principles on handling protected health information (PHI), an overview of patient rights, general administrative safeguards that protect PHI, an overview of extreme risk protection orders (ERPOs), and how to handle breaches to PHI.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Describe the basic provisions of the Privacy Rule under HIPAA.</li>\r\n    <li>Recognize the requirements and components of the Notice of Privacy Practices.</li>\r\n    <li>Describe the Breach Notification Rule.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DA1A6031-6D0A-F011-9997-005056A7AAEE",
                "course_category_name": "HSTM - ComplyQ for Rev Cycle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Privacy and Security",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EFA61FCF-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - ComplyQ Acute [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9B9EDD5-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8BB82E9D-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - ComplyQ [All Settings] [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                "course_category_name": "_ComplyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5656D88F-CE7A-EB11-80DE-005056B16973",
                "course_category_name": "KnowledgeQ Microlearning (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E52CB629-9691-EB11-80E1-005056B13D3F",
                "course_category_name": "KnowledgeQ Microlearning Compliance - HIPAA (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "90B55558-03C9-E511-8771-005056B104B1",
                "course_category_name": "Urgent Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "82CDE1E0-3FD6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                "course_category_name": "Competency: HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "67CCBB16-6533-EC11-80E9-005056B14E20",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "74C43481-BB8C-EB11-80DF-005056B16DD5",
        "course_version": 5,
        "name": "CQ Acute: HIPAA, Security Rule",
        "course_type": 1,
        "author_information": "Jen Bailey McKinney, MBA",
        "description": "This module provides an overview of the HIPAA Security Rule. It includes a review of how to protect electronic protected health information (ePHI), behaviors and situations that put ePHI at risk, the safeguards and requirements of the Security Rule, and reporting possible violations.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Distinguish the HIPAA Privacy Rule from the HIPAA Security Rule.</li>\r\n    <li>\r\n    Identify common behaviors and situations that put PHI at risk for unintended disclosure.</li>\r\n    <li>\r\n    Identify external risks to PHI.</li>\r\n    <li>\r\n    Identify best practices and required safeguards organizations must take to ensure appropriate protection of electronic protected health information.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Privacy and Security",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9B9EDD5-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EFA61FCF-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - ComplyQ Acute [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                "course_category_name": "_ComplyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8BB82E9D-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - ComplyQ [All Settings] [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                "course_category_name": "Competency: HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "90B55558-03C9-E511-8771-005056B104B1",
                "course_category_name": "Urgent Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "67CCBB16-6533-EC11-80E9-005056B14E20",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers",
                "is_system_course_category": null
            },
            {
                "course_category_id": "82CDE1E0-3FD6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E52CB629-9691-EB11-80E1-005056B13D3F",
                "course_category_name": "KnowledgeQ Microlearning Compliance - HIPAA (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "424639E0-BB8C-EB11-80DF-005056B16DD5",
        "course_version": 6,
        "name": "CQ Acute: HIPAA, Violations and Penalties",
        "course_type": 1,
        "author_information": "Tasha Deitschman, MSN, RN, CPPS",
        "description": "This module will provide an overview of the HIPAA Privacy Rule\u2019s disclosure violations as well as the associated penalties. It will define and discuss examples of breaches of protected health information (PHI) as well as review commonly occurring HIPAA compliance issues.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define a breach of protected health information (PHI). </li>\r\n    <li>\r\n    Describe and give an example of an exemption to a breach of PHI.</li>\r\n    <li>\r\n    Describe three types of Privacy disclosure violations and give examples of each.</li>\r\n    <li>\r\n    Recognize commonly occurring HIPAA compliance issues. </li>\r\n    <li>\r\n    Describe the civil and criminal penalties associated with HIPAA violations.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "67CCBB16-6533-EC11-80E9-005056B14E20",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "82CDE1E0-3FD6-EC11-80F1-005056B17FCD",
                "course_category_name": "Parent: HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "752F23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E52CB629-9691-EB11-80E1-005056B13D3F",
                "course_category_name": "KnowledgeQ Microlearning Compliance - HIPAA (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "90B55558-03C9-E511-8771-005056B104B1",
                "course_category_name": "Urgent Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "69E799A8-FB16-EC11-80E5-005056B108B1",
                "course_category_name": "Competency: HIPAA",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D9332047-F47A-ED11-80FB-005056B17014",
                "course_category_name": "_ComplyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8BB82E9D-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - ComplyQ [All Settings] [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "473D6AB7-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream ComplyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DA1A6031-6D0A-F011-9997-005056A7AAEE",
                "course_category_name": "HSTM - ComplyQ for Rev Cycle",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D6135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "All Disciplines",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "26C04B86-AF06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Privacy and Security",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EFA61FCF-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - ComplyQ Acute [LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C9B9EDD5-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - Compliance: HIPAA for Providers (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "B17188C2-DAE4-EB11-80E4-005056B107A8",
        "course_version": 9,
        "name": "SQ Acute: Abduction, Infant and Child",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews the root causes of infant and child abductions, a healthcare worker's role in preventing them, and the best practices for keeping infants and children safe in a facility.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the characteristics of an abductor.\u202f </li>\r\n    <li>\r\n    Identify best practices for preventing abduction.\u202f </li>\r\n    <li>\r\n    State\u202fwhat\u202ffamily education will help prevent abduction.\u202f </li>\r\n    <li>\r\n    State what staff education will help prevent abduction.\u202f </li>\r\n    <li>\r\n    Describe\u202fthe appropriate staff response to an attempted or actual abduction.<br class=\"t-last-br\" />\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "122F6D1F-C126-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: Patient or Resident Security",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66142DFA-07FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Birthing Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                "course_category_name": "School",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Advocacy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Patient or Resident Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "FF35B3C6-2125-EC11-80E6-005056B12213",
        "course_version": 9,
        "name": "SQ Acute: Abuse and Neglect",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module helps learners recognize and understand the different types of abuse, the signs of abuse, and the reporting requirements of suspected or confirmed abuse.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define abuse </li>\r\n    <li>Identify types of abuse and related signs and symptoms.\r\n    </li>\r\n    <li>    Describe actions to take to protect individuals from abuse. </li>\r\n    <li> Describe the reporting requirements for suspected or confirmed abuse.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0BB4475A-25C9-E511-8771-005056B104B1",
                "course_category_name": "Gerontology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "55C9834D-0286-E811-9579-005056B150D1",
                "course_category_name": "Hospice",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DA6A4541-D28C-EB11-80DF-005056B134EC",
                "course_category_name": "Mandatory Reporting",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B0FAB4D3-9106-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Abuse and Neglect",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "56EBAE7E-25C9-E511-8771-005056B104B1",
                "course_category_name": "Home Healthcare",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3F4D9D32-F3FD-E611-BC44-005056B10E33",
                "course_category_name": "Correctional",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C6B37F61-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Rehabilitation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E23CFC1B-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Dialysis",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "957F716A-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Infusion Therapy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "51FB57AE-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Intimate Partner Violence",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "57DADFC8-E203-E911-A43F-005056B13721",
                "course_category_name": "Sexual Abuse & Assault",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4A566AD5-0186-E811-A5DD-005056B150D3",
                "course_category_name": "Pain",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0A2A275A-23C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "736CD86E-6E7C-EB11-80DF-005056B108B1",
                "course_category_name": "NRSRES - Nurse Residency - Manage with Content Package",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FA20BE9F-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Elder Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9E2202A8-0386-E811-ABAD-005056B17F80",
                "course_category_name": "School",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7064D866-23C9-E511-8771-005056B104B1",
                "course_category_name": "Ambulatory Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A0CBF9A6-C98C-EB11-80DF-005056B134EC",
                "course_category_name": "Child Abuse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "77F6B8A5-EC87-EB11-80E0-005056B135DF",
        "course_version": 8,
        "name": "SQ Acute: Adverse Drug Events",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module helps learners recognize adverse events, distinguish their severity, and identify populations at risk.",
        "learning_objectives_html": "<p>Upon the completion of this module, the participant will be able to:\r\n</p>\r\n<ul>\r\n    <li>Define adverse drug events and list four types.</li>\r\n    <li>Distinguish the severity level of adverse drug reactions.</li>\r\n    <li>Recognize when to report drug reactions to the appropriate healthcare practitioner.</li>\r\n    <li>Recognize when to report drug reactions to MedWatch.</li>\r\n    <li>Identify populations at greatest risk of adverse drug events.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D8CF904-C697-EB11-80DE-005056B160AF",
                "course_category_name": "Food & Drug Administration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pharmacist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "736CD86E-6E7C-EB11-80DF-005056B108B1",
                "course_category_name": "NRSRES - Nurse Residency - Manage with Content Package",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3B291ABF-6F7C-EB11-80DF-005056B108B1",
                "course_category_name": "NRSRES",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2CB1C04-8706-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Adverse Drug Events",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "FC09FAD0-0588-EB11-80E0-005056B135DF",
        "course_version": 7,
        "name": "SQ Acute: Antibiotic Resistance",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews what happens when antibiotics do not stop germs as they should, antibiotic use, and how to protect people from antibiotic resistance.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the infection prevention and control requirements and antibiotic stewardship Conditions of Participation (CoP).</li>\r\n    <li>Identify three actions that healthcare providers can take to protect individuals in their care and people in their community from antibiotic-resistant infections.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9996B0CC-BF26-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: Antibiotic Stewardship",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pharmacist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "310C1FC5-2225-EC11-80E6-005056B12213",
        "course_version": 9,
        "name": "SQ Acute: Bloodborne Pathogens and Standard Precautions, Clinical",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews how to protect yourself, coworkers, patients, and family from bloodborne pathogens. Discussion is included on bloodborne pathogens found in the blood and body fluids and how\u00a0they\u00a0spread, as well as Standard Precautions\u00a0to\u00a0prevent the spread of these pathogens.\u00a0The content in this module is designed for clinical personnel.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Identify bloodborne pathogens risks to healthcare workers and the individuals they care for.\r\n    </li>\r\n    <li>    Describe protective measures to minimize exposure risk\r\n    </li>\r\n    <li>    Discuss the appropriate actions to take in the event of exposure to a bloodborne pathogen&nbsp; &nbsp; &nbsp;</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Infection Control and Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B0B50CB8-8506-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4FF3BFFA-D08C-EB11-80DF-005056B134EC",
                "course_category_name": "Bloodborne Pathogens",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CED83BE-FF85-E811-AD45-005056B16A47",
                "course_category_name": "Occupational Safety & Health Administration",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "FD79B860-C07D-EB11-80DF-005056B16236",
        "course_version": 12,
        "name": "SQ Acute: Care Delivery, Culturally Competent",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module describes what culture means and how care that is sensitive to culture provides the best medical outcomes. Unequal and unfair treatment causes harm, and cultural sensitivity promotes fair medical treatment to reduce risk of harm.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define culture.</li>\r\n    <li>\r\n    List three outcomes of fair and equal treatment that is sensitive to culture. </li>\r\n    <li>\r\n    List three outcomes of unfair and unequal treatment that is not sensitive to culture.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5656D88F-CE7A-EB11-80DE-005056B16973",
                "course_category_name": "KnowledgeQ Microlearning (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C4C69461-2D0C-EC11-80E5-005056B16B79",
                "course_category_name": "Competency: Cultural Competency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "ADFB6B18-D5C9-E511-82AF-005056B150D3",
                "course_category_name": "Cultural Awareness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "BFBDE0BD-A805-EC11-80E5-005056B107A8",
        "course_version": 9,
        "name": "SQ Acute: COVID-19 Emergency Temporary Standard",
        "course_type": 1,
        "author_information": "Kathleen Greene-Batt",
        "description": "This module reviews the OSHA Emergency Temporary Standard. It has been updated to include information based on changes made since the end of the federal Public Health Emergency was declared.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>List three ways that COVID-19 is transmitted.</li>\r\n    <li>Identify signs and symptoms of COVID-19.</li>\r\n    <li>Identify required protective measures to take when working with suspected or confirmed cases of COVID-19.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "21EE8A43-2DCB-E311-A9A9-005056B14441",
                "course_category_name": "HSTM - KnowledgeQ by HealthStream - NO PERMISSIONS",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E4265595-BE26-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: COVID-Related",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                "course_category_name": "Disaster Planning",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "0EF774EB-2525-EC11-80E6-005056B12213",
        "course_version": 7,
        "name": "SQ Acute: Emergency Preparedness",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module provides an overview of an emergency preparedness program, including the structure of a program and why emerging infectious diseases should be considered. The module will also discuss staff roles and training in response to an emergency.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe an emergency preparedness program.\r\n    </li>\r\n    <li>    Explain the importance of including emerging infectious diseases in the hazard assessment and planning for these situations.\r\n    </li>\r\n    <li>    Describe staff responsibilities during an emergency.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C74C5EEC-1C42-11DD-8EF5-001517135513",
                "course_category_name": "Disaster Planning",
                "is_system_course_category": null
            },
            {
                "course_category_id": "068B2671-9206-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Emergency Preparedness",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Workplace Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "4A49CD6D-2625-EC11-80E6-005056B12213",
        "course_version": 6,
        "name": "SQ Acute: Ergonomics and Safe Lifting, Clinical",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module defines ergonomics and gives examples of where and how ergonomics can be applied in the workplace. Musculoskeletal disorders (MSDs) are explained and suggestions are made about how to prevent back pain and injury using ergonomic tools and equipment. The module also reviews three primary risk factors for injury during physical tasks, proper body mechanics for manual lifting, when to use mechanical equipment or assistive devices, and gives examples of lifting equipment and assistive devices. This module content is designed for clinical personnel.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe the principles of ergonomics and their applications.\r\n    </li>\r\n    <li>    Describe risk factors that increase the risk of musculoskeletal disorders (MSDs).\r\n    </li>\r\n    <li>    Identify measures that healthcare workers can take to reduce risk of injury to oneself or the person being moved.\r\n    </li>\r\n    <li>    Explain why the basic principles of lifting an object do not apply well to lifting or moving people.</li>\r\n    <li>Describe how to determine if a transfer device is needed.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D04DB9A7-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Workflow Efficiency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "09A3C12D-D505-EC11-80E5-005056B107A8",
                "course_category_name": "Risk Area: Employee Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                "course_category_name": "Workforce Culture",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6D11B708-6F06-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Ergonomics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "83F09B51-2725-EC11-80E6-005056B12213",
        "course_version": 9,
        "name": "SQ Acute: Fire Safety",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews the basics of fire safety, how to respond to a fire in a facility, and how to prevent fires from happening.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Describe required safety features and other methods to prevent, suppress, and extinguish fires.</li>\r\n    <li>Identify OSHA and CMS regulations for fire safety.\r\n    </li>\r\n    <li>    Recognize risk factors for fire related to the fire triangle. </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C4246662-9206-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Fire Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "98B27526-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Electrical Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Workplace Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "59A5B984-2725-EC11-80E6-005056B12213",
        "course_version": 7,
        "name": "SQ Acute: Hazard Communication",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module explains how OSHA's Hazard Communication Standard (HCS) classifies a chemical as a physical hazard or a health hazard and reviews specific PPE that should be used when working near or with hazardous chemicals. The module also explains in detail what must be on a label, including explanations of the nine pictograms, as well as the sixteen components of a safety data sheet (SDS).",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify types of chemical hazards in the healthcare setting.\r\n    </li>\r\n    <li>    Discuss protective measures used when working with hazardous chemicals.\r\n    </li>\r\n    <li>    Recognize three common chemical hazards in hospitals: Formaldehyde , Glutaraldehyde, and Ethylene Oxide.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DE9EE97E-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Workplace Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Effective Communication",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5559DC85-9206-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Hazard Communication",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "AD27F147-EB8B-EB11-80E0-005056B13D3F",
        "course_version": 7,
        "name": "SQ Acute: Infection, Emerging",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module provides an overview of emerging infections. It includes a review of factors that influence the emergence of new pathogens and examples of recent emergent infections. This module also discusses how staff can prepare and learn about new emerging infections.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Define emerging infections. </li>\r\n    <li>\r\n    Describe factors that influence the emergence of new and evolving pathogens.  </li>\r\n    <li>\r\n    Recognize several emergent infections which have occurred over the last 50 years and discuss their impact.  </li>\r\n    <li>\r\n    Discuss emergency preparedness regulations in relation to emerging infectious diseases. </li>\r\n    <li>\r\n    Identify where and how clinicians and other healthcare workers can learn about emerging health threats.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D62C2A1-136D-E911-9E21-005056B13721",
                "course_category_name": "Conditions of Participation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Personal Protective Equipment",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BC8209E9-BE26-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: Infectious Diseases",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "25D79CB3-F687-EB11-80E0-005056B135DF",
        "course_version": 7,
        "name": "SQ Acute: Infection, Healthcare-Associated, Clinical",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module covers infection control and antibiotic stewardship in healthcare, and reviews reportable infections and how to protect individuals from them. This module will also discuss healthcare-associated infections that are of urgent concern. This content is designed for clinical personnel.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the characteristics of effective Infection Control and Antibiotic Stewardship Programs.\r\n    </li>\r\n    <li>    Identify several resistant pathogens that seriously threaten healthcare.\r\n    </li>\r\n    <li>    Identify actions that healthcare professionals can take to protect patients and stop outbreaks from resistant pathogens.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Infection Control and Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7D62C2A1-136D-E911-9E21-005056B13721",
                "course_category_name": "Conditions of Participation",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9FEBCF0-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Personal Protective Equipment",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "085322BE-8506-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Healthcare-Associated Infections",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "05CAEA43-CE7D-EB11-80DF-005056B134EC",
        "course_version": 9,
        "name": "SQ Acute: Infection, Transmission-Based Precautions",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module provides an overview of strategies and controls designed to prevent the healthcare-associated transmission of pathogens by the contact, droplet, and airborne routes.",
        "learning_objectives_html": "Upon completion of this module, participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify common pathogens that require transmission-based precautions. </li>\r\n    <li>\r\n    Identify ways to prevent infections from being transmitted by contact, droplet, and airborne routes.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "BD9F31D2-8506-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Transmission-Based Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5F3A8743-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Infection Control and Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5656D88F-CE7A-EB11-80DE-005056B16973",
                "course_category_name": "KnowledgeQ Microlearning (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F52D6401-D18C-EB11-80DF-005056B134EC",
                "course_category_name": "Airborne, Droplet, and Isolation Precautions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "3E729F5F-2825-EC11-80E6-005056B12213",
        "course_version": 6,
        "name": "SQ Acute: Medication Management, Clinical",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews ordering, scheduling, and identifying medications. It will also identify best practices for preparing and administering medications along with the documentation requirements needed.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify safe practices for medication administration.</li>\r\n    <li>Distinguish the risks related to medication management.</li>\r\n    <li>Describe documentation requirements related to medication administration and  monitoring.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Medication Administration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Medication Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "10BF132F-F587-EB11-80E0-005056B135DF",
        "course_version": 8,
        "name": "SQ Acute: Medications, Hazardous",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module discusses the characteristics of hazardous medications. It will identify potential risks and best practices during preparation, administration, care, and disposal. This will also review the importance of medical surveillance.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify characteristics of hazardous medications and how they can cause harm.</li>\r\n    <li>\r\n    Identify potential exposure risks in each step of medication handling and use.</li>\r\n    <li>\r\n    Locate credible resources for hazardous medication handling.</li>\r\n    <li>\r\n    Describe best practices to prevent exposure to hazardous medications\r\n    during preparation administration, patient care, and disposal.</li>\r\n    <li>\r\n    Describe the requirement for medical surveillance when handling hazardous medications routinely.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Medication Administration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DC261434-EBF9-E611-AF66-005056B104B1",
                "course_category_name": "Oncologic Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                "course_category_name": "Competency: High Risk Medications",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "D770FFFA-FA87-EB11-80E0-005056B135DF",
        "course_version": 8,
        "name": "SQ Acute: Medications, High-Alert",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "According to the\u00a0Institute for Safe Medication Practices (ISMP), high-alert medications are those that have an increased risk of causing significant patient harm when used in error.\u00a0This module will review some important information on the ISMP list and best practices when managing patients receiving high-alert medications.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Give examples of the most common high-alert medication classes.</li>\r\n    <li>\r\n    Identify recommended strategies for protecting individuals from adverse drug events. </li>\r\n    <li>\r\n    Recognize the appropriate response to a medication error.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Medication Administration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C2068A6B-F3FD-E611-BC44-005056B10E33",
                "course_category_name": "Diabetic Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "830AFE10-8706-EC11-80E6-005056B16973",
                "course_category_name": "Competency: High Risk Medications",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "0A1BFB07-F487-EB11-80E0-005056B135DF",
        "course_version": 6,
        "name": "SQ Acute: Medications, Interactions",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module covers causes and types of common medication interactions. It emphasizes the important role of the pharmacist and describes actions to reduce the risk of an adverse medication event. Taking more than one medication increases the risk because medications can interact with each other and either increase or decrease the effects or cause side effects.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify causes of drug-drug interactions.</li>\r\n    <li>\r\n    Identify types of medication interactions.</li>\r\n    <li>\r\n    Recognize the role of the pharmacist related to safe medication practices.</li>\r\n    <li>\r\n    Describe best practices to prevent medication interactions.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2E449059-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Medication Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5189FB23-8706-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Medication Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8C02850F-CC8C-EB11-80DF-005056B134EC",
                "course_category_name": "Medication Administration",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "4AD1688B-FC87-EB11-80E0-005056B135DF",
        "course_version": 9,
        "name": "SQ Acute: Medications, Preventing Rehospitalization",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module will identify medication groups that may increase risk of rehospitalizations and emergency department visits from adverse drug events (ADE). The module will also discuss best practices to help decrease or prevent hospital visits due to ADEs.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify medication groups known to increase risk for emergency department visits and hospitalizations.</li>\r\n    <li>\r\n    Describe clinical considerations and best practices when individuals require certain medications. </li>\r\n    <li>\r\n    Describe the role of professional responsibility in decreasing emergency room visits and hospitalizations in relation to ADEs.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "01265A0C-C126-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: Discharge Planning",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Patient or Resident Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "E7410B84-617B-EB11-80DF-005056B11841",
        "course_version": 8,
        "name": "SQ Acute: Patient Rights, Advance Directives",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module describes advance directives and provides an overview of different types and how the directives differ from advance orders. The module also discusses legal requirements and healthcare provider roles.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>Define and describe types of advance directives.\r\n    </li>\r\n    <li>    Distinguish advance directives from advance orders.\r\n    </li>\r\n    <li>    Describe a healthcare professional&rsquo;s role related to advance directives.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Advocacy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D26135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Pharmacist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Rights and Responsibilities",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F7C5BD13-9206-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Advance Directives",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "73DA135E-2925-EC11-80E6-005056B12213",
        "course_version": 9,
        "name": "SQ Acute: Patient Rights, Clinical",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module emphasizes the importance of understanding and respecting patient rights. It includes the list of patient rights from the Conditions of Participation (CoP) for hospitals. This content is intended for clinical personnel.",
        "learning_objectives_html": "Upon the completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify the patient's rights under the conditions of participation for hospitals.</li>\r\n    <li>\r\n    Recognize a healthcare professional's responsibilities regarding patient rights.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Rights and Responsibilities",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "8433B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Emergency Services",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "64AC0E63-34D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Advocacy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2115A6DC-9106-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Patient Rights",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "9B03A252-2025-EC11-80E6-005056B12213",
        "course_version": 8,
        "name": "SQ Acute: Restraint and Seclusion",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews the basics of restraints and the risks associated with restraints and seclusion. The CMS Conditions of Participation guidelines for the use of restraints and seclusion are discussed.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Describe required elements of the Restraint and Seclusion Conditions of Participation.\r\n    </li>\r\n    <li>    Identify potential risks when using both physical and chemical restraint.\r\n    </li>\r\n    <li>    Identify early intervention strategies to prevent or mitigate challenging behaviors.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "00EA8185-7386-EA11-8340-005056B14F90",
                "course_category_name": "Long Term Acute Care Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DF0AFF1A-9206-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Restraints and Seclusion",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Rights and Responsibilities",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "F7E4C291-0988-EB11-80E0-005056B135DF",
        "course_version": 7,
        "name": "SQ Acute: Suicide Risks and Prevention",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module reviews the risk factors and warning signs of a suicidal patient. It suggests what a healthcare worker can do to help prevent a person from committing suicide. It also offers information on resources for the patient, family, and healthcare worker.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Identify individuals who are at risk for self-harm.\r\n    </li>\r\n    <li>    Recognize environmental safety risks for those at risk for self-harm.\r\n    </li>\r\n    <li>    Describe safety interventions for those at risk for self-harm for individuals on non-psychiatric units.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7DC22D7D-6E98-EB11-80E1-005056B145B3",
                "course_category_name": "KnowledgeQ Microlearning Patient Safety (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A9A5001-8806-EC11-80E6-005056B16973",
                "course_category_name": "Competency: Suicide Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B9B7575F-02C9-E511-8771-005056B104B1",
                "course_category_name": "Behavioral Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "00EA8185-7386-EA11-8340-005056B14F90",
                "course_category_name": "Long Term Acute Care Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D0F18666-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Patient or Resident Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    },
    {
        "course_id": "01EF70A5-EB7D-EB11-80DF-005056B134EC",
        "course_version": 8,
        "name": "SQ Acute: Workplace Violence",
        "course_type": 1,
        "author_information": "Valerie Crossland",
        "description": "This module discusses the risks and warning signs of workplace violence in healthcare and provides de-escalation tips to protect yourself and others. It also presents the elements of an effective workplace violence prevention program.",
        "learning_objectives_html": "Upon completion of this module, the participant will be able to:\r\n<ul>\r\n    <li>\r\n    Recognize the risks and warning signs of violence in  the workplace.</li>\r\n    <li>\r\n    Identify de-escalation best practices. </li>\r\n    <li>\r\n    Understand the key elements of a workplace violence prevention plan.</li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "955D3EDB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Pediatric Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Oncology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38184F6-1BC9-E511-8771-005056B104B1",
                "course_category_name": "Hospitalist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FD26E3C2-9222-EA11-AC06-005056B1522B",
                "course_category_name": "Trauma",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D86135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Respiratory Therapist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C447C7BA-D905-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - SafetyQ Acute [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "31CED46F-6E06-EC11-80E6-005056B16973",
                "course_category_name": "Risk Area: Rights and Responsibilities",
                "is_system_course_category": null
            },
            {
                "course_category_id": "19D0098D-A6BA-E811-82BD-005056B17C80",
                "course_category_name": "Registered Nurse First Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A6B32998-70F4-EB11-80E4-005056B16236",
                "course_category_name": "Tier One",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Neurology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "33607431-5FF9-E611-B748-005056B122EA",
                "course_category_name": "Maternal Newborn",
                "is_system_course_category": null
            },
            {
                "course_category_id": "07ADC272-25A9-EC11-80F0-005056B129DA",
                "course_category_name": "HSTM - Hospital Compliance Training for Clinical Students (Manage Publishing with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0DFB1B0D-04C9-E511-8771-005056B104B1",
                "course_category_name": "Anesthesiologist Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A1CF818-E95A-DB11-A964-000423ACEF71",
                "course_category_name": "HealthStream",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6618DFF7-A7BA-E811-B23F-005056B17E48",
                "course_category_name": "Military Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "F9B6D3DD-40F8-EF11-9993-005056A730AF",
                "course_category_name": "HSTM - SafetyQ [All Settings] [Curric & LP Publish] (Manage Subscribers with Content Package)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E8A2EF17-22C9-E511-8771-005056B104B1",
                "course_category_name": "Respiratory Therapy Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0F99537E-AF63-E511-9870-005056B15839",
                "course_category_name": "Cardiovascular Technologist and Technician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "921D4F4A-DE56-ED11-80F6-005056B160AF",
                "course_category_name": "_SafetyQ: Acute",
                "is_system_course_category": null
            },
            {
                "course_category_id": "23BE09FB-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Post Anesthesia Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "AB0E13B0-F2FD-E611-BC44-005056B10E33",
                "course_category_name": "Case Management",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C0C8BD30-0AFE-E611-A7FF-005056B16BE3",
                "course_category_name": "Trauma Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2DCBA462-F4FD-E611-BC44-005056B10E33",
                "course_category_name": "Endoscopy",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9D311C25-F5FD-E611-BC44-005056B10E33",
                "course_category_name": "Orthopedics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "71B23AFD-09FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Rural Health Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "34CFCC0F-25C9-E511-8771-005056B104B1",
                "course_category_name": "Emergency",
                "is_system_course_category": null
            },
            {
                "course_category_id": "40AC33B7-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Medical Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                "course_category_name": "Workforce Culture",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3CA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Pediatrics",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4D1B82BB-02C9-E511-8771-005056B104B1",
                "course_category_name": "Hospital",
                "is_system_course_category": null
            },
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "E54CFB9C-02C9-E511-8771-005056B104B1",
                "course_category_name": "Government/VA Facility",
                "is_system_course_category": null
            },
            {
                "course_category_id": "CF91A6E4-F6FD-E611-BC44-005056B10E33",
                "course_category_name": "Progressive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "787C7F5C-979E-E511-9627-005056B1456A",
                "course_category_name": "Nursing Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "42C036BC-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Wound Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5D87D306-DCE1-EC11-80F2-005056B14C8B",
                "course_category_name": "Parent: HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D93E3454-A5BA-E811-82BD-005056B17C80",
                "course_category_name": "Cardiovascular Perfusionist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician",
                "is_system_course_category": null
            },
            {
                "course_category_id": "03A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Cardiology",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A56135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Emergency Medical Technician and Paramedic",
                "is_system_course_category": null
            },
            {
                "course_category_id": "9CDE68BF-D405-EC11-80E5-005056B107A8",
                "course_category_name": "HSTM - HealthStream SafetyQ",
                "is_system_course_category": null
            },
            {
                "course_category_id": "FECBA0D1-08FE-E611-A7FF-005056B16BE3",
                "course_category_name": "Medical Center",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD11353E-BA97-EB11-80DE-005056B160AF",
                "course_category_name": "Occupational Stress",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0B2A2D13-CD8C-EB11-80DF-005056B134EC",
                "course_category_name": "Injury Prevention",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5594B2CA-25C9-E511-8771-005056B104B1",
                "course_category_name": "Neonatal Intensive Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1D5C5A97-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Women's Health",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D2215BC8-20DF-E511-B3E9-005056B150D3",
                "course_category_name": "New Graduate Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A38C7BB8-5EF9-E611-B748-005056B122EA",
                "course_category_name": "Pediatric Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DD9181A3-DF03-E911-AB1A-005056B14F90",
                "course_category_name": "Clinical Educator",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1644F350-F485-E811-91D1-005056B133C3",
                "course_category_name": "Clinical Manager",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6CAD973E-1DC9-E511-8771-005056B104B1",
                "course_category_name": "Licensed Practical and Licensed Vocational Nurse - LPN",
                "is_system_course_category": null
            },
            {
                "course_category_id": "DBCB64F6-23C9-E511-8771-005056B104B1",
                "course_category_name": "Critical Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "52A45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Surgery",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF06CF05-F7FD-E611-BC44-005056B10E33",
                "course_category_name": "Telemetry",
                "is_system_course_category": null
            },
            {
                "course_category_id": "A337536A-C126-EC11-80E8-005056B135DF",
                "course_category_name": "Competency: Workplace Violence",
                "is_system_course_category": null
            },
            {
                "course_category_id": "5656D88F-CE7A-EB11-80DE-005056B16973",
                "course_category_name": "KnowledgeQ Microlearning (NO PA)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4DCCDD5D-E203-E911-90AD-005056B14D10",
                "course_category_name": "Clinical Preceptor",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D16135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician Assistant",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C89EA002-2CC9-E511-8771-005056B104B1",
                "course_category_name": "Perioperative",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];